<template>
  <v-app>
    <v-app-bar app>
      <router-link to="/">
        <v-toolbar-title>ブッタイ!!</v-toolbar-title>
      </router-link>
      <span class="subtitle"> 一期一会のブックタイトル。 </span>
      <v-spacer></v-spacer>
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on">
            <v-icon>mdi-bookshelf</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item v-for="(item, index) in items" :key="index">
            <router-link :to="item.to">
            <v-list-item-title>{{ item.title }}</v-list-item-title>
            </router-link>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <v-main>
      <router-view></router-view>
    </v-main>

    <v-footer>
      <v-card-text
        >ブッタイ!! 一期一会のブックタイトル。by
        <a href="https://miyazadaniels.com">miyazadaniels</a>
      </v-card-text>
    </v-footer>
  </v-app>
</template>

<script>
export default {
  name: "App",
  data: () => ({
    items: [{ title: "Home", to: "/" }, { title: "About", to: "/about" }],
  }),
};
</script>

<style>
.v-application a:link,
.v-application a:visited,
.v-application a:hover,
.v-application a:active {
  color: #333333 !important;
  text-decoration: none;
}
.subtitle {
  font-size: 0.75rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: 10px;
}
.container {
  font-family: "Zen Old Mincho" !important;
}
.v-app-bar, .v-list-item__title {
  font-family: "Yuji Boku" !important;
}
.v-footer {
  font-family: "Yuji Boku" !important;
  font-size: 0.7rem;
}
</style>